import { getDataMapper, mapField, mapArray } from "@/shared";

function CategoriesMeta() {
    this.id = mapField("id");
    this.text = mapField("title");
    // loadCategories уже прогоняет данные через mapCategoriesFromServer (camelCase:
    // tariffs/cashDeposit/discounts), поэтому читаем именно эти поля. Количество
    // инвентаря API не отдаёт (count всегда 0) → бейдж количества/«пусто» убран.
    this.discounts = mapField("discounts");
    this.tariffs = mapField("tariffs");
    this.cashDeposit = mapField("cashDeposit", Number);
    this.children = mapField("children", this);
}

export const mapCategoryToBaseTree = getDataMapper(new CategoriesMeta());

export const mapCategoriesToBaseTree = mapArray(mapCategoryToBaseTree);
